/**
 * Shared US ZIP validation for delivery zone + pickup location checkers.
 */
(function () {
  var ZIP_PATTERN = /^\d{5}(-\d{4})?$/;

  function normalize(value) {
    return String(value || '').trim();
  }

  function sanitizeInput(value) {
    var cleaned = String(value || '').replace(/[^\d-]/g, '');

    if (cleaned.indexOf('-') !== cleaned.lastIndexOf('-')) {
      cleaned = cleaned.replace(/-/g, '');
    }

    if (cleaned.length > 5 && cleaned.indexOf('-') === -1) {
      cleaned = cleaned.slice(0, 5) + '-' + cleaned.slice(5, 9);
    }

    return cleaned.slice(0, 10);
  }

  function isValid(value) {
    return ZIP_PATTERN.test(normalize(value));
  }

  window.WonderlyZipCheck = {
    normalize: normalize,
    sanitizeInput: sanitizeInput,
    isValid: isValid,
  };
})();
